import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'next/head';
import { Constants } from '../../adapters/helpers/Constants';
import { customJsonstringify } from '../../adapters/helpers/Utils';
import DOMPurify from 'isomorphic-dompurify';
class BreadCrumbSEO extends PureComponent {
  constructor(props) {
    super(props);
    const {
      breadcrumb
    } = props;
    const BASE_URL = process.env.BASE_URL;
    this.itemList = breadcrumb && breadcrumb.map((breadcrumb, key) => {
      var _breadcrumb$fields, _breadcrumb$fields$ti, _breadcrumb$fields2;
      return {
        '@type': Constants.ListItem,
        position: key + 1,
        name: breadcrumb == null ? void 0 : (_breadcrumb$fields = breadcrumb.fields) == null ? void 0 : (_breadcrumb$fields$ti = _breadcrumb$fields.title) == null ? void 0 : _breadcrumb$fields$ti.toUpperCase(),
        item: `${BASE_URL}${breadcrumb == null ? void 0 : (_breadcrumb$fields2 = breadcrumb.fields) == null ? void 0 : _breadcrumb$fields2.link}`
      };
    });
  }
  render() {
    return <Helmet>
                <script type={Constants.typeLD} dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(`{
                            "@context":"${Constants.context}",
                            "@type": "${Constants.breadcrumb}",
                            "itemListElement": ${customJsonstringify(this.itemList)}
                        }`)
      }} />
            </Helmet>;
  }
}
BreadCrumbSEO.propTypes = {
  breadcrumb: PropTypes.array.isRequired
};
export default BreadCrumbSEO;